module.exports = __webpack_public_path__ + "img/logo-white.ea1b8f31.png";